//////////////////////////////////////////////////////////////////////////
//
//  Copyright (C) 2007-2023 zSpace, Inc.  All Rights Reserved.
//
//////////////////////////////////////////////////////////////////////////

import * as THREE from 'three';
import {GLTFLoader} from 'three/examples/jsm/loaders/GLTFLoader';
import exitButtonGlbUrl from './demo/assets/models/exit_button.glb';

var ExitButton = function(){
  THREE.Object3D.call(this);

  this.loader = new GLTFLoader();
  this.loader.load(
    exitButtonGlbUrl,
    (gltf)=>{
      let meshes = [];
      gltf.scene.traverse((obj)=>{
        if(obj.isMesh){
          meshes.push(obj);
          obj.frustumCulled = false;
//          obj.addEventListener('dragBegin', this.dragBegin.bind(this));
//          obj.addEventListener('dragUpdate', this.dragUpdate.bind(this));
          obj.addEventListener('dragEnd', this.dragEnd.bind(this));
        }
      });
      meshes.forEach(mesh => this.add(mesh));
      this.dispatchEvent({type:'meshesLoaded'});
    },
    (xhr)=>{
      console.log('loading exit button: ' + (xhr.loaded/xhr.total*100) + '%');
    },
    (error)=>{
      console.log('error while loading exit button\n' + error);
    }
  );

  this.visible = false;
  this.dragPointer = null;
  this.dragOffset = new THREE.Matrix4();
  this._xrSession = null;
}

ExitButton.prototype =
  Object.assign(Object.create(THREE.Object3D.prototype),{
  constructor: ExitButton,

//  dragBegin: function(event){
//    if(this.dragPointer === null && event.button === 0){
//      this.dragPointer = event.pointer;
//      this.dragOffset.copy(this.matrixWorld);
//      this.dragOffset.premultiply(new THREE.Matrix4().getInverse(
//        this.dragPointer.matrixWorld));
//    }
//  },

//  dragUpdate: function(){
//    if(this.dragPointer){
//      this.matrixWorld.copy(this.dragOffset);
//      this.matrixWorld.premultiply(this.dragPointer.matrixWorld);
//      this.matrix.copy(this.matrixWorld);
//
//      if(this.parent){
//        this.matrix.premultiply(new THREE.Matrix4().getInverse(
//          this.parent.matrixWorld));
//      }
//
//      this.matrix.decompose(
//        this.position,
//        this.quaternion,
//        this.scale);
//    }
//  },

  dragEnd: function(event){
    this.dispatchEvent({type:'click'});
    //if(this.dragPointer === event.pointer){
    //  this.dragPointer = null;
    //}
  }
});

////////////////////////////////////////////////////////////////////////////////
// Accessors ///////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////////

// ExitButton.prototype = Object.create(ExitButton.prototype, {
//   xrSession:{
//     get: function(){
//       return this._xrSession;
//     },
// 
//     set: function(value){
//       this.visible = true;
//       this._xrSession = value;
//       this._xrSession.addEventListener('sessionStart', ()=>{
//         this.visible = true;
//       });
//       this._xrSession.addEventListener('sessionEnd', ()=>{
//         this.visible = false;
//       });
//     }
//   }
// });

export { ExitButton };
